const RegisterData = {
    // Search
    form: {
        token_id: '',
        name: '',
        phonetic: '',
        top_news: '',
        concept: '',

        //エリアデータ
        areaLv1: [],
        areaLv2: [],
        areaLv3: [],

        selectAreaLv1: [],
        selectAreaLv2: [],
        selectAreaLv3: [],

        // detail
        rate_dm_form: '',
        rate_min: '',
        rate_max: '',
        box_price_min: '',
        box_price_max: '',
        one_gram: '',
        gram_price_min: '',
        gram_price_max: '',
        b_sales_recruitment: [],
        c_sales_recruitment: [],
        //カテゴリデータ
        categoriyLv1: [],
        categoriyLv2: [],
        categoriyLv3: [],

        //カテゴリ保存用データ(重複なし)
        Lv1: [],
        Lv2: [],
        Lv3: [],

        //価値評価用カテゴリ
        select_priceZone_categoriyLv1: [],
        select_priceZone_categoriyLv2: [],
        select_price_zone_guidelines: [],

        price_min: '',
        price_max: '',
        target_min: '',
        target_max: '',
        sales_style: [],
        order: [],
        web_url: '',
        pay_rule: [],
        net_shop: '',
        base: '',

        hashtag: [],

        // 会社情報
        company_name: '',
        company_phonetic: '',
        // company_kind: '',
        company_type: '',
        company_post_code: '',
        company_address: '',
        google_map_url: '',
        company_tel: '',
        company_facebook_url: '',
        company_twitter_url: '',
        company_instagram_url: '',
        company_line_url: '',
        company_concept: '',
        registration_plan: '',

        //ユーザー情報
        invitation_email: '',

        // 画像データ関係
        main_images: [],
        sub_images: [],
        price_images: [],
        delete_images : [],

        // hitotonari
        hitotonari: {
            image: [],
            position: '',
            name: '',
            title: '',
            text: '',
            history: '',
            facebook: '',
            twitter: '',
            instagram: '',
            display: '',
            questionAndAnswers: [],
        },

        // Sns Accounts
        snsAccounts: {
            facebook: '',
            twitter: '',
            instagram: '',
            line: '',
        },

        // 展示会
        editExhibitionTitles:[],
        exhibition_titles:[],
        editExhibitions:[],
        exhibitions:[],

        //youtube
        editYoutube:[],
        youtubes:[],

        address: '',
        handling_brand: '',

        //contact
        mail: '',
        tel: '',

        //sales_brands
        sales_brands: '',
        other_brand: '',
    },

    //cropper用
    crop: {
        image_target:'',
        temp_image:'',
    },

    //編集画面の表示用
    set: {
        sales_recruitment: [],
        categories: [],
        sales_style: [],
        order: [],
        pay_rule: [],
        areas: [],
    },

    errors: {
        name: false,
        phonetic: false,
        main_images: false,
        concept: false,
        category: false,
        price_min: false,
        price_max: false,
        target_min: false,
        target_max: false,
        web_url: false,
        net_shop: false,
        base: false,
        tel: false,
        mail: false,
    },
}

export default RegisterData
